<template>
  <div class="header">
    <div class="header-top">
      <div style="text-align: left; flex: 1">欢迎使用物润产融供应链平台</div>
      <div style="text-align: right; flex: 1">
        客服热线<img src="../assets/Public/iphone.png" />0512-56308111
      </div>
    </div>
    <div class="header-fotter">
      <div style="width: 24%; text-align: left; padding-left: 30px">
        <img src="../assets/Public/wrcl-logo.png" />
      </div>
      <div style="width: 55%">
        <app-side></app-side>
      </div>
      <div style="width: 19%">
        <el-button type="primary" round @click="dialogFormVisible" style="margin-right:10px;">申请入驻</el-button>
        <el-button type="primary" round @click="GoLogin">去登录</el-button>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogFormVis"
      center
      width="590px"
      :before-close="handleClose"
    >
      <div slot="title" class="dialog-title">申请入驻</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        :label-width="formLabelWidth"
        :label-position="labelPosition"
      >
        <!-- <el-form-item label="来源" prop="source">
          <el-select v-model="ruleForm.source" placeholder="请选择来源">
            <el-option label="客户拜访" value="客户拜访"></el-option>
            <el-option label="客户来访" value="客户来访"></el-option>
            <el-option label="电话拜访" value="电话拜访"></el-option>
            <el-option label="相关引荐" value="相关引荐"></el-option>
            <el-option label="网络意向" value="网络意向"></el-option>
            <el-option label="行业相关" value="行业相关"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="线索类型" prop="type">
          <el-select v-model="ruleForm.type" placeholder="请选择线索类型">
            <el-option label="企业" value="1"></el-option>
            <el-option label="个人" value="2"></el-option>
            <el-option label="学校" value="3"></el-option>
            <el-option label="政府机构" value="4"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="联系人" prop="contacts">
          <el-input v-model="ruleForm.contacts"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="telephone">
          <el-input v-model="ruleForm.telephone"></el-input>
        </el-form-item>
        <!-- <el-form-item label="意向描述" prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="营业执照" prop="business_license"> -->
        <!-- <el-input v-model="ruleForm.business_license"></el-input> -->
        <!-- <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="ruleForm.business_license"
              :src="ruleForm.business_license"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="avatar-uploader-div">支持格式BMP、JPEG、GIF、PNG, 大小不超过4M</div>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div>提交信息后，我们将尽快与您联系。</div>
        <el-button type="primary" @click="submitForm('ruleForm')">提 交</el-button>
        <el-button @click="resetForm('ruleForm')" style="margin-left: 30px"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import appSide from "./appSide.vue";
export default {
  name: "AppHeader",
  components: {
    appSide,
  },
  data() {
    //手机号验证
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        // console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      labelPosition: "left",
      dialogFormVis: false,
      ruleForm: {
        source: "网络意向", //来源
        name: "", //线索全程
        type: "1", //线索类型
        contacts: "", //联系人
        telephone: "", //电话
        desc: "供应链入驻咨询", //意向描述
        business_license: "", //营业执照
      },
      formLabelWidth: "100px",
      rules: {
        // source: [{ required: true, message: "请选择来源", trigger: "change" }],
        name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          { max: 50, message: "公司名称最大不超过 50 个字符", trigger: "blur" },
        ],
        // type: [{ required: true, message: "请选择线索类型", trigger: "change" }],
        contacts: [{ required: true, message: "请输入联系人姓名", trigger: "blur" }],
        telephone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        // desc: [
        //   { required: true, message: "请填写意向描述", trigger: "blur" },
        //   { max: 125, message: "意向描述最大不超过 125 个字符", trigger: "blur" },
        // ],
        // business_license: [
        //   { required: true, message: "请上传营业执照", trigger: "blur" },
        // ],
      },
    };
  },
  methods: {
    // 图片上传
    // handleAvatarSuccess(res, file) {
    //   this.business_license = URL.createObjectURL(file.raw);
    //   console.log(res,file)
    // },
    // beforeAvatarUpload(file) {
    //   // const testmsg = file.type === "image/jpeg";
    //   var testmsg = /^image\/(bmp|jpeg|gif|png)$/.test(file.type);
    //   const isLt4M = file.size / 1024 / 1024 < 4;

    //   if (!testmsg) {
    //     this.$message.error("营业执照图片格式不正确!");
    //   }
    //   if (!isLt4M) {
    //     this.$message.error("营业执照图片大小不能超过 4MB!");
    //   }
    //   return testmsg && isLt4M;
    // },
    // 确定提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.source= "网络意向"
          this.ruleForm.type= "1"
          this.ruleForm.desc= "供应链入驻咨询"
          // console.log(this.ruleForm)
          this.$api.SettleInSubmit(this.ruleForm).then((res) => {
            // console.log(res);
          });
          this.dialogFormVis = false;
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVis = false;
    },
    dialogFormVisible() {
      (this.ruleForm = {
        source: "",
        name: "",
        type: "",
        contacts: "",
        telephone: "",
        desc: "",
      }),
        (this.dialogFormVis = true);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          location.reload();
        })
        .catch((_) => {});
    },
    //跳转去登录
    GoLogin(){
      window.open('http://uac.ship56.net/#/login', "_blank"); 
    }
  },
};
</script>

<style lang="scss" scoped>
.header {
  height: 100%;
  background: #ffffff;
  line-height: 70px;
  border-bottom: 1px solid #e4e7ed;
  overflow-x: auto;
  overflow-y: hidden;
}
.header::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  text-align: left;
}
.header-top {
  padding: 0px 30px;
  height: 30px;
  line-height: 30px;
  display: flex;
  background-color: #f5f5f6;
  font-size: 12px;
}
.header-top img {
  width: 16px;
  height: 16px;
  margin: 0 8px;
  vertical-align: middle;
}
.header-fotter {
  display: flex;
}
.header-fotter img {
  width: 160px;
  height: 50px;
  vertical-align: middle;
}
.el-button.is-round {
  border-radius: 20px;
  padding: 8px 20px;
}
// 申请入住弹框开始
/deep/.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 25px 0px 25px;
}
/deep/.el-dialog__header {
  line-height: 50px;
  background: #2f82ff;
  border-radius: 8px 8px 0px 0px;
  padding: 5px 20px;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
  font-size: 30px;
  line-height: 30px;
}
.dialog-title {
  text-align: left;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
/deep/.el-dialog,
.el-dialog--center {
  border-radius: 8px;
}
/deep/.el-form-item__content {
  display: flex;
}
/deep/.el-select {
  flex: 1;
}
// /deep/.avatar-uploader-div {
//   margin: auto;
//   flex: 1;
//   font-size: 13px;
//   padding: 0 50px;
//   color: #999999;
//   line-height: 18px;
// }
// /deep/.avatar-uploader .el-upload {
//   border: 1px dashed #d9d9d9;
//   border-radius: 6px;
//   cursor: pointer;
//   position: relative;
//   overflow: hidden;
// }
// /deep/.avatar-uploader .el-upload:hover {
//   border-color: #409eff;
// }
// /deep/.avatar-uploader-icon {
//   font-size: 28px;
//   color: #8c939d;
//   width: 128px;
//   height: 128px;
//   line-height: 128px;
//   text-align: center;
// }
/deep/.avatar {
  width: 128px;
  height: 128px;
  display: block;
}
/deep/.el-dialog__footer {
  padding: 0px 20px 20px 20px;
}
.dialog-footer {
  // line-height: 18px;
  div {
    font-size: 13px;
    color: #2f82ff;
    line-height: 26px;
  }
  .el-button {
    padding: 10px 30px;
  }
}

// 申请入住弹框结束
</style>
